
<!--
  - Copyright (c) 2022 by Leyton Group - All Rights Reserved.
  - This source code, and resulting software, is the confidential and proprietary information
  - ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  - of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  - and shall use it only in accordance with the terms and conditions of any and all license
  - agreements you have entered into with The Company.
  -->

<template>
  <div id="Roles">
    <b-row align-items="stretch">
      <b-col cols="12" xl="12">
        <div class="roles-row" v-if="getRoles.content">

          <h3 class="block-title">Rôles existants</h3>
          <VueSlickCarousel ref="rolesCarousel" :arrows="false" :rows="1" :slidesPerRow="1" :slidesToShow="4">

            <div v-for="(role, index) in getRoles.content" :key="index" class="role-item">
              <!-- {{role}} -->
              <div class="role-item_content">
                <h5>{{role.name}}</h5>
                <p>
                  {{role.description}}
                </p>
                <button
                    class="actions-button"
                    v-if="role !== null && (role.roleType !== ROLE_TYPE.ADMIN_AGENCE && role.roleType !== ROLE_TYPE.USER)"
                    @click="showRolesActions(role.id)">
                  <svg width="3" height="12" viewBox="0 0 3 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="1.5" cy="1.5" r="1.5" fill="white"/>
                    <circle cx="1.5" cy="6" r="1.5" fill="white"/>
                    <circle cx="1.5" cy="10.5" r="1.5" fill="white"/>
                  </svg>
                </button>
                <ul class="role-actions" :class="{'toggledRoleActions' : roleActions === index}">
                  <li class="role-action_item">
                    <button @click="modifyRole(role)">
                      <i class="edit-icon">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.10352e-05 8.19292V9.82639C6.10352e-05 9.97684 0.118272 10.0951 0.268723 10.0951H1.90219C1.97204 10.0951 2.04189 10.0682 2.09025 10.0145L7.95783 4.15225L5.94286 2.13728L0.0806596 7.99949C0.0269272 8.05322 6.10352e-05 8.1177 6.10352e-05 8.19292ZM9.51607 2.59401C9.72563 2.38445 9.72563 2.04594 9.51607 1.83638L8.25873 0.579042C8.04917 0.369486 7.71066 0.369486 7.5011 0.579042L6.5178 1.56235L8.53277 3.57731L9.51607 2.59401Z" fill="#132D48"/>
                        </svg>
                      </i>
                      <span>Modifier</span>
                    </button>
                    </li>
                  <li class="role-action_item">
                    <button @click="openConfirmDeleteModal(role.id)">
                      <i class="delete-icon">
                        <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.17244 2.26755V1.47061C7.17244 0.945731 6.77397 0.508789 6.22436 0.508789H3.44607C2.8992 0.508789 2.50074 0.945731 2.50074 1.47061V2.26755H0V3.14693H0.252822C0.252822 3.14693 0.401217 3.16342 0.478163 3.24036C0.555108 3.31731 0.585337 3.48769 0.585337 3.48769L1.10747 10.1298C1.14869 10.9377 1.14869 11.0613 2.09677 11.0613H7.5764C8.52449 11.0613 8.52449 10.9404 8.56571 10.1325L9.08784 3.49318C9.08784 3.49318 9.11807 3.32006 9.19501 3.24311C9.27196 3.16616 9.42035 3.14968 9.42035 3.14968H9.67317V2.2703H7.17244V2.26755ZM3.07783 1.47061C3.07783 1.2068 3.29218 1.0584 3.56423 1.0584H6.08421C6.35627 1.0584 6.59535 1.20954 6.59535 1.47061V2.26755H3.07783V1.47061ZM2.84424 9.30259L2.56119 4.02631H3.11905L3.4076 9.30259H2.84424ZM5.14162 9.30259H4.53705V4.02631H5.14162V9.30259ZM6.83443 9.30259H6.27382L6.56237 4.02631H7.12023L6.83443 9.30259Z" fill="#132D48"/>
                        </svg> 
                      </i>
                      <span>Supprimer</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>


          </VueSlickCarousel>
          <button class="slick-arrow slick-next" @click="showNext">
            <svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.462693 14.6513C0.0721687 15.0418 0.0721687 15.675 0.462693 16.0655C0.853217 16.456 1.48638 16.456 1.87691 16.0655L0.462693 14.6513ZM7.96225 8.56594L8.66936 9.27305C9.05988 8.88253 9.05988 8.24936 8.66936 7.85884L7.96225 8.56594ZM1.87691 1.06639C1.48638 0.675861 0.853217 0.675861 0.462692 1.06639C0.0721681 1.45691 0.0721681 2.09007 0.462692 2.4806L1.87691 1.06639ZM1.87691 16.0655L8.66936 9.27305L7.25515 7.85884L0.462693 14.6513L1.87691 16.0655ZM8.66936 7.85884L1.87691 1.06639L0.462692 2.4806L7.25515 9.27305L8.66936 7.85884Z" fill="#132D48"/>
            </svg>
          </button>
          <button class="slick-arrow slick-prev" @click="showPrev">
            <svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.462693 14.6513C0.0721687 15.0418 0.0721687 15.675 0.462693 16.0655C0.853217 16.456 1.48638 16.456 1.87691 16.0655L0.462693 14.6513ZM7.96225 8.56594L8.66936 9.27305C9.05988 8.88253 9.05988 8.24936 8.66936 7.85884L7.96225 8.56594ZM1.87691 1.06639C1.48638 0.675861 0.853217 0.675861 0.462692 1.06639C0.0721681 1.45691 0.0721681 2.09007 0.462692 2.4806L1.87691 1.06639ZM1.87691 16.0655L8.66936 9.27305L7.25515 7.85884L0.462693 14.6513L1.87691 16.0655ZM8.66936 7.85884L1.87691 1.06639L0.462692 2.4806L7.25515 9.27305L8.66936 7.85884Z" fill="#132D48"/>
            </svg>
          </button>
        </div>

        <div class="add-new_role-row">
          <h3 class="block-title">Ajouter un nouveau rôle</h3>
          <div class="add-new_role">
            <div class="row">
              <div class="col-lg-5">
                <div class="giga-fields">
                  <div class="giga-input_field full-field">
                      <label class="input-field_label">Nom de rôle</label>
                      <div class="input-field_area">
                          <input type="text" v-model="$v.roleForm.name.$model">
                      </div>
                      <div v-if="$v.roleForm.name.$anyDirty && $v.roleForm.name.$invalid">
                        <small class="form-text text-danger" v-if="!$v.roleForm.name.required">
                          {{$t('required_field')}}
                        </small>
                      </div>
                  </div>
                  <div class="giga-input_field full-field">
                    <label class="input-field_label">Accès</label>
                    <div class="input-field_area">
                      <multiselect
                        open-direction="bottom"
                        :searchable="false"
                        :closeOnSelect="false"
                        :value="$v.roleForm.permissions.$model"
                        :options="permissions"
                        :multiple="true"
                        :showLabels="false"
                        :isRequired="$v.roleForm.$anyDirty"
                        :reduce="permission => permission.value"
                        trackBy="value"
                        label="name"
                        v-on:select="selectPermissions"
                        v-on:remove="removePermissions"
                      >
                      <template slot="caret">
                        <div class="multiselect__select d-flex align-items-center justify-content-center">
                          <div v-if=" permissions.value && permissions.length " class="text-primary">
                            <b-icon icon="pencil-fill"></b-icon>
                          </div>
                          <div v-else>
                            <b-icon icon="chevron-down"></b-icon>
                          </div>
                        </div>
                      </template>
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-7">
                <div class="giga-fields">
                  <div class="giga-input_field full-field">
                    <label class="input-field_label">Description du rôle</label>
                    <div class="input-field_area input_textarea">
                        <textarea v-model="$v.roleForm.description.$model"></textarea>
                    </div>
                    <div v-if="$v.roleForm.description.$anyDirty && $v.roleForm.description.$invalid">
                      <small class="form-text text-danger" v-if="!$v.roleForm.description.required">
                        {{$t('required_field')}}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="giga-document_footer giga-flex giga-flex_end">
            <div class="giga-button">
              <button class="giga-green_button no-icon" @click="onRoleModalConfirm()" :disabled="$v.roleForm.$invalid || validateClicked">
                <span v-if="!validateClicked">Mettre à jour</span>
                <b-spinner
                    v-else
                    style="width: 1.5rem; height: 1.5rem;"
                    variant="primary" class="mr-2 align-middle">
                </b-spinner>

              </button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
<!--    <role-modal-->
<!--      :id="roleModalId"-->
<!--      :title="modalTitle"-->
<!--      :isReadOnly="isReadOnly"-->
<!--      :roleForm="roleForm"-->
<!--      :clickedPermission="clickedPermission"-->
<!--      :permissions="permissions"-->
<!--      :validateClicked="validateClicked"-->
<!--      :nextClicked="nextClicked"-->
<!--      :loader="addRoleLoader"-->
<!--      fontSize="h3"-->
<!--      backdrop-close="false"-->
<!--      @confirmClick="onRoleModalConfirm()"-->
<!--      @closeClick="closeModalRole()"-->
<!--    ></role-modal>-->
    <confirm-modal
      :id="deleteModalId"
      :content="$t(modalContent)"
      :loader="false"
      fontSize="h3"
      backdrop-close="false"
      @yesClick="DeleteModelConfirm()"
      @close="hideConfirmationModal()"
    ></confirm-modal>
  </div>
</template>

<script>
import {queryConstant} from "@/shared/queryConstant";
import {constants} from "@/shared/constants";
import {roleService} from "@/views/service/role.service";
import {mapActions, mapGetters} from "vuex";
import ConfirmModal from "@/components/static/ConfirmModal";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import _, {remove} from "lodash";
import i18n from "@/i18n";
import {required} from "vuelidate/lib/validators";

export default {
  name: "Roles",
  data: function () {
    const _pageSize_10 = 10;
    const _pageSize_25 = 25;
    const _pageSize_50 = 50;

    return {
      acces: ['Tous les accès', 'Ouvrages', 'Simulations', 'Facturation', 'Réglementaire', 'Contrats', 'Contacts', 'Team'],
      roleActions: -1,
      roleModalId: "",
      modalTitle: "",
      isReadOnly: false,
      roleForm: {
        name: "",
        description: "",
        permissions: [],
      },
      modifRoleForm: {
        name: "",
        description: "",
        permissions: [],
      },
      permissions: [],

      nextClicked: false,
      validateClicked: false,

      clickedPermission: null,
      scrollBarSettings: {
        scrollXMarginOffset: 50,
      },
      rolePagedFilter: {
        myPager: {
          page: 1,
          size: 10,
          defaultSort: "id",
          defaultOrder: true,
        },
        search: "",
        customFilter: queryConstant.setDefaultCustomFilter(),
      },
      deleteModalId: "",
      modalContent: "",
      idRoleToDelete: "",
      length: [_pageSize_10, _pageSize_25, _pageSize_50],
      rolesQueryConfig: queryConstant.ROLES_CONFIG,
      toggleRoleActions: false,
      ROLE_TYPE: constants.ROLE_TYPE
    };
  },
  validations: {
    roleForm: {
      name: {
        required
      },
      description: {
        required
      },
      permissions: {
        required
      }
    }
  },
  mounted() {
    this.permissions = _.map(constants.ROLE_PERMISSIONS, function (item) {
      return { name: i18n.t(item), value: item };
    });

  },
  methods: {
    ...mapActions("role", ["fetchRolesAction"]),
    ...mapActions("account", ["changeCurrentStepAction"]),
    ...mapActions("notification", ["openModal", "closeModal"]),

    showRolesActions(id){
      this.roleActions = this.getRoles.content.findIndex((item) => item.id == id)
      this.toggleRoleActions = !this.toggleRoleActions
    },
    onRoleModalConfirm() {
      this.roleForm.permissions = this.roleForm.permissions
        .map((per) => {
          return { name: per.value };
        });
      this.validateClicked = true;
      if (this.roleModalId === "modify-role") {
        this.onModifRoleModalConfirm();
      } else {
        this.onAddRoleModalConfirm();
      }
    },
    modifyRole(role) {
      this.roleActions = -1;
      this.roleModalId = "modify-role";
      this.modalTitle = "Modifier Rôle";
      this.isReadOnly = false;
      this.roleForm.id = role.id;
      this.roleForm.name = role.name;
      this.roleForm.description = role.description;
      this.roleForm.permissions = this.permissions.filter(permission => {
            return role.permissions.find(rolePerm => rolePerm.name === permission.value)
      });
    },

    openConfirmDeleteModal(idRole) {
      this.roleActions = -1;
      this.idRoleToDelete = idRole;
      this.deleteModalId = "confirm-delete-answer";
      this.modalContent = "would-you-like-to-delete-this-role";
      this.doOpenConfirmModal();
    },

    doOpenConfirmModal() {
      setTimeout(() => {
        this.openModal({ instance: this.$root, id: this.deleteModalId });
      }, 1);
    },
    hideConfirmationModal() {
      this.idRoleToDelete = null;
      this.closeModal({ instance: this.$root, id: this.deleteModalId });
    },
    DeleteModelConfirm() {
      roleService
        .deleteRole(this.idRoleToDelete)
        .then((res) => {
          this.hideConfirmationModal();
          this.fetchRoles();
        })
        .catch((err) => {
          console.log("error ", err);
        });
      this.hideConfirmationModal();
    },
    onAddRoleModalConfirm() {
      const data = {
        name: this.roleForm.name,
        description: this.roleForm.description,
        permissions: this.roleForm.permissions,
      };
      roleService.createRole(data).then((res) => {
        this.$v.$reset();
        this.roleForm = {
          name: "",
          description: "",
          permissions: [],
        };
        this.validateClicked = false;
        this.fetchRoles();
      });
    },
    fetchRoles() {
      this.fetchRolesAction({ pagedFilter: this.rolePagedFilter });
    },
    onModifRoleModalConfirm() {
      const data = {
        id: this.roleForm.id,
        name: this.roleForm.name,
        description: this.roleForm.description,
        permissions: this.roleForm.permissions,
      };
      roleService.modifyRole(data).then(() => {
        this.$v.$reset();
        this.roleForm = {
          name: "",
          description: "",
          permissions: [],
        };
        this.validateClicked = false;
        this.fetchRoles();
      });
    },
    showNext() {
      this.$refs.rolesCarousel.next()
    },
    showPrev(){
      this.$refs.rolesCarousel.prev()
    },
    selectPermissions(option) {
      this.$v.roleForm.permissions.$model = [...this.$v.roleForm.permissions.$model, ...[option]];
      switch (option.value) {
        case constants.VIEW_PROJECT:
          this.$v.roleForm.permissions.$model.push({value: constants.VIEW_SIMULATION});
          break;
        case constants.VIEW_SIMULATION:
          this.$v.roleForm.permissions.$model.push({value: constants.VIEW_PROJECT});
          break;
        case constants.CREATE_SIMULATION: case constants.VALIDATE_SIMULATION:
          if (!this.$v.roleForm.permissions.$model.some(p => p.value === constants.VIEW_PROJECT
                || p.value === constants.VIEW_SIMULATION)) {
            this.$v.roleForm.permissions.$model.push({value: constants.VIEW_PROJECT});
            this.$v.roleForm.permissions.$model.push({value: constants.VIEW_SIMULATION});
          }
          break;
      }
    },
    removePermissions(option) {
      const arr = [...this.$v.roleForm.permissions.$model];
      switch (option.value) {
        case constants.VIEW_SIMULATION: case constants.VIEW_PROJECT:
          remove(arr,
                  p => p.value === constants.VIEW_SIMULATION || p.value === constants.VIEW_PROJECT
                  || p.value === constants.VALIDATE_SIMULATION || p.value === constants.CREATE_SIMULATION);
          break;
        case constants.VALIDATE_SIMULATION:
          if (arr.some(p => p.value === constants.CREATE_SIMULATION)) {
            remove(arr, p => p.value === constants.VALIDATE_SIMULATION);
          } else {
            remove(arr,
                p => p.value === constants.VIEW_SIMULATION || p.value === constants.VIEW_PROJECT
                    || p.value === constants.VALIDATE_SIMULATION);
          }
          break;
        case constants.CREATE_SIMULATION:
          if (arr.some(p => p.value === constants.VALIDATE_SIMULATION)) {
            remove(arr, p => p.value === constants.CREATE_SIMULATION);
          } else {
            remove(arr,
                p => p.value === constants.VIEW_SIMULATION || p.value === constants.VIEW_PROJECT
                  || p.value === constants.CREATE_SIMULATION);
          }
          break;
        default:
          remove(arr, p => p.value === option.value);
          break;
      }
      this.$v.roleForm.permissions.$model= arr;
    }
  },
  computed: {
    ...mapGetters("role", ["getRoles"]),
    ...mapGetters("loader", {
      loading: "getLoading",
      addRoleLoader: "getAddRoleLoader",
    }),
  },
  components: { VueSlickCarousel, ConfirmModal },
  created() {
    this.fetchRoles();
  },
};
</script>

<style scoped>
</style>
